export const MYFRAMES_ORDER_TYPE_DROP_SHIP = '1';
export const MYFRAMES_ORDER_TYPE_STORE = '0';

export type MyFramesOrderTypeEmailState = {
    isMyFrames: boolean;
    orderTypeValue: string;
    email: string | null | undefined;
    accountEmail: string | null | undefined;
    dropShipEmailDraft: string | null;
};

export type MyFramesOrderTypeEmailResult = {
    isDropShip: boolean;
    emailReadOnly: boolean;
    showAccountEmailHint: boolean;
    email: string;
    dropShipEmailDraft: string | null;
};

export function myframesOrderTypeValue(isDropShip: boolean): string {
    return isDropShip ? MYFRAMES_ORDER_TYPE_DROP_SHIP : MYFRAMES_ORDER_TYPE_STORE;
}

export function isDropShipOrderType(orderTypeValue: string): boolean {
    return orderTypeValue === MYFRAMES_ORDER_TYPE_DROP_SHIP;
}

export function isMyFramesEmailReadOnly(isMyFrames: boolean, orderTypeValue: string): boolean {
    return !!isMyFrames && !isDropShipOrderType(orderTypeValue);
}

function asEmail(value: string | null | undefined): string {
    return value ?? '';
}

export function resolveMyFramesOrderTypeEmail(state: MyFramesOrderTypeEmailState, options?: {captureDropShipDraft?: boolean}): MyFramesOrderTypeEmailResult {
    const captureDropShipDraft = options?.captureDropShipDraft === true;
    const isDropShip = isDropShipOrderType(state.orderTypeValue);
    const emailReadOnly = isMyFramesEmailReadOnly(state.isMyFrames, state.orderTypeValue);

    if (!state.isMyFrames) {
        return {
            isDropShip,
            emailReadOnly: false,
            showAccountEmailHint: false,
            email: asEmail(state.email),
            dropShipEmailDraft: state.dropShipEmailDraft,
        };
    }

    let dropShipEmailDraft = state.dropShipEmailDraft;
    let email = asEmail(state.email);

    if (!isDropShip) {
        if (captureDropShipDraft) {
            dropShipEmailDraft = email;
        }
        email = asEmail(state.accountEmail);
    } else if (dropShipEmailDraft !== null) {
        email = dropShipEmailDraft;
    }

    return {
        isDropShip,
        emailReadOnly,
        showAccountEmailHint: emailReadOnly,
        email,
        dropShipEmailDraft,
    };
}

export function transitionMyFramesOrderTypeEmail(state: MyFramesOrderTypeEmailState, nextOrderTypeValue: string): MyFramesOrderTypeEmailResult {
    const captureDropShipDraft = isDropShipOrderType(state.orderTypeValue) && !isDropShipOrderType(nextOrderTypeValue);
    return resolveMyFramesOrderTypeEmail(
        {
            ...state,
            orderTypeValue: nextOrderTypeValue,
        },
        {captureDropShipDraft},
    );
}
